import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import type { JSX } from 'react';
const Loading = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col justify-center items-center mb-8"><Shimmer height="28px" width="323px" className="mb-4" /><Shimmer height="34px" width="380px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pt-[34px] sm:pt-[56px] sm:-mb-[9px]">{t0}<div className="flex flex-col justify-center items-center"><Shimmer height="66px" width="100%" className="mb-8" /><Shimmer height="66px" width="100%" className="mb-10" /><Shimmer height="42px" width="100%" className="hidden sm:block" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Loading;